import { AccountSecurityAction, AccountSecurityActionType } from './accountSecurityActionType';
import { IAccountSecurityState } from './accountSecurityState';
import {
    RevokeSessionAction,
    RevokeSessionActionTypes,
} from './revokeSession/revokeSessionActionTypes';
import { UpdateEmailAction, UpdateEmailActionType } from './updateEmail/updateEmailActionType';
import {
    UpdatePasswordAction,
    UpdatePasswordActionType,
} from './updatePassword/updatePasswordActionType';
import {
    UpdateUsernameAction,
    UpdateUsernameActionType,
} from './updateUsername/updateUsernameActionType';
import { VerifyEmailAction, VerifyEmailActionTypes } from './verifyEmail/verifyEmailActionTypes';

export function accountSecurityReducer(
    state: IAccountSecurityState = {
        overlayOpen: false,
        updatingEmail: false,
        updatingPassword: false,
        updatingUsername: false,
        sendOtpTimes: 0,
        stateCodes: [],
        emailOtpIntervalTime: 0,
        verifyFailed: false,
        tooManySendOtpRequests: false,
        tooManyVerifyOtpRequests: false,
        overlayContent: undefined,
        verifyingEmail: '',
        sendOtpSuccess: true,
        passwordValid: false,
        password: '',
        isVerifyEmailFromUpdateEmail: false,
        sendingOtp: false,
        sessionRevocationEnabled: false,
        isSessionRevoked: false,
        signOutFromAllDevices: false,
        errorRevokingSession: undefined,
    },
    action:
        | AccountSecurityAction
        | UpdateEmailAction
        | UpdatePasswordAction
        | UpdateUsernameAction
        | VerifyEmailAction
        | RevokeSessionAction,
): IAccountSecurityState {
    switch (action.type) {
        case AccountSecurityActionType.CLOSE_ACCOUNT_SECURITY_OVERLAY:
            return {
                ...state,
                overlayOpen: false,
                isVerifyEmailFromUpdateEmail: false,
                sendOtpTimes: 0,
            };

        case AccountSecurityActionType.OPEN_ACCOUNT_SECURITY_OVERLAY:
            return {
                ...state,
                overlayOpen: true,
            };

        case AccountSecurityActionType.CLEAR_PASSWORD:
            return {
                ...state,
                password: '',
            };

        case AccountSecurityActionType.CHANGE_ACCOUNT_SECURITY_OVERLAY:
            const overlayContent = action.payload;
            return {
                ...state,
                overlayContent,
            };

        case UpdateEmailActionType.UPDATE_EMAIL_REQUEST:
            return {
                ...state,
                updatingEmail: true,
            };

        case UpdateEmailActionType.UPDATE_EMAIL_SUCCESS:
            return {
                ...state,
                overlayOpen: false,
                updatingEmail: false,
            };

        case UpdateEmailActionType.UPDATE_EMAIL_FAILURE:
            return {
                ...state,
                updatingEmail: false,
            };

        case UpdatePasswordActionType.UPDATE_PASSWORD_REQUEST:
            return {
                ...state,
                updatingPassword: true,
            };

        case UpdatePasswordActionType.UPDATE_PASSWORD_SUCCESS:
            return {
                ...state,
                overlayOpen: false,
                updatingPassword: false,
            };

        case UpdatePasswordActionType.UPDATE_PASSWORD_FAILURE:
            return {
                ...state,
                updatingPassword: false,
            };

        case UpdateUsernameActionType.UPDATE_USERNAME_REQUEST:
            return {
                ...state,
                updatingUsername: true,
            };

        case UpdateUsernameActionType.UPDATE_USERNAME_SUCCESS:
            return {
                ...state,
                overlayOpen: false,
                updatingUsername: false,
            };

        case UpdateUsernameActionType.UPDATE_USERNAME_FAILURE:
            return {
                ...state,
                updatingUsername: false,
            };
        case VerifyEmailActionTypes.SEND_OTP_REQUEST:
            return {
                ...state,
                sendOtpTimes: state.sendOtpTimes + 1,
                sendingOtp: true,
            };
        case VerifyEmailActionTypes.SEND_OTP_SUCCESS:
            return {
                ...state,
                sendOtpSuccess: true,
                sendingOtp: false,
            };
        case VerifyEmailActionTypes.SEND_OTP_FAILURE:
            return {
                ...state,
                sendOtpSuccess: false,
                sendingOtp: false,
            };
        case VerifyEmailActionTypes.CLEAR_OTP_TIMES:
            return {
                ...state,
                sendOtpTimes: 0,
            };
        case VerifyEmailActionTypes.VERIFY_EMAIL_FAILURE:
            return { ...state, verifyFailed: true };
        case VerifyEmailActionTypes.DISABLE_VERIFY_EMAIL_FAILURE:
            return { ...state, verifyFailed: false };
        case VerifyEmailActionTypes.TOO_MANY_SEND_OTP_REQUESTS:
            return { ...state, tooManySendOtpRequests: action.payload, sendingOtp: false };
        case VerifyEmailActionTypes.TOO_MANY_VERIFY_OTP_REQUESTS:
            return { ...state, tooManyVerifyOtpRequests: action.payload };
        case VerifyEmailActionTypes.SET_VERIFYING_EAMIL:
            if (state.verifyingEmail !== action.payload) {
                return {
                    ...state,
                    verifyingEmail: action.payload,
                    tooManyVerifyOtpRequests: false,
                    verifyFailed: false,
                };
            }
            return { ...state };
        case VerifyEmailActionTypes.VLIDATE_PASSWORD_REQUEST:
            return { ...state, updatingEmail: true, password: action.payload };
        case VerifyEmailActionTypes.VALIDATE_PASSWORD_SUCCESS:
            return { ...state, passwordValid: true, updatingEmail: false };
        case VerifyEmailActionTypes.VALIDATE_PASSWORD_FAILED:
            return { ...state, passwordValid: false, updatingEmail: false };
        case VerifyEmailActionTypes.SET_PASSWORD_VALID_FALSE:
            return { ...state, passwordValid: false };
        case VerifyEmailActionTypes.SET_VARIFY_EMAIL_FROM_UPDATE_EMAIL:
            return { ...state, isVerifyEmailFromUpdateEmail: true };
        case RevokeSessionActionTypes.SEND_SESSION_REVOKE_REQUEST:
            return { ...state, isSessionRevoked: false };
        case RevokeSessionActionTypes.SEND_SESSION_REVOKE_SUCCESS:
            return { ...state, isSessionRevoked: true, signOutFromAllDevices: false };
        case RevokeSessionActionTypes.SEND_SESSION_REVOKE_FAILURE:
            const payload = action.payload;
            return {
                ...state,
                isSessionRevoked: false,
                signOutFromAllDevices: false,
                errorRevokingSession: payload.errorResolution,
            };
        case RevokeSessionActionTypes.SET_SESSION_REVOKE:
            return { ...state, signOutFromAllDevices: action.payload };
        default:
            return state;
    }
}
